import React, { useCallback, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { setChatWindowProperties } from '../utils/chatUtils';

const ENTERPRISE_HUB_URL = process.env.REACT_APP_SNOW_SP_URL;
const CHAT_URI = process.env.REACT_APP_CHAT_URI;

const LegacyChat = ({ userInfo, autoOpenChat, setAutoOpenChat, chatTicketId, chatSysId }) => {
    const { t } = useTranslation();
    const iframeRef = useRef(null);

    // Set window properties for the iframe to read via window.parent.*
    useEffect(() => {
        if (autoOpenChat && userInfo) {
            setChatWindowProperties(userInfo, chatTicketId, chatSysId);
        }
    }, [autoOpenChat, userInfo, chatTicketId, chatSysId]);

    // Poll iframe to detect when the chat widget closes (body becomes empty)
    const handleIframeLoad = useCallback(() => {
        const interval = setInterval(() => {
            try {
                const iframeDoc = iframeRef.current?.contentDocument || iframeRef.current?.contentWindow?.document;
                if (iframeDoc && iframeDoc.body && iframeDoc.body.innerHTML.trim() === '') {
                    clearInterval(interval);
                    setAutoOpenChat(false);
                }
            } catch (e) {
                // Cross-origin — cannot inspect; stop polling
                clearInterval(interval);
            }
        }, 1000);
        return () => clearInterval(interval);
    }, [setAutoOpenChat]);

    // When autoOpenChat is active, render embedded chat iframe
    if (autoOpenChat && userInfo) {
        return (
            <div className="w-full pt-[5.5rem]" style={{ height: 'calc(100vh - 9rem)', display: 'flex', flexDirection: 'column' }}>
                <iframe
                    ref={iframeRef}
                    src={CHAT_URI}
                    title="IT Support Chat"
                    onLoad={handleIframeLoad}
                    style={{
                        width: '100%',
                        flex: 1,
                        border: 'none'
                    }}
                    sandbox="allow-same-origin allow-scripts allow-forms allow-popups"
                />
            </div>
        );
    }

    return null;
};

export default LegacyChat;
